<span [ngClass]="isActive ? 'text-blue-600' : 'text-gray-300'" class="font-medium" [innerHtml]="chevronIcon | safeSvg"></span>
